import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import api from '../config/api';
import MaintenancePage from '../pages/MaintenancePage';

const MaintenanceCheck = ({ children }) => {
  const [loading, setLoading] = useState(true);
  const [maintenanceMode, setMaintenanceMode] = useState(false);
  const [maintenanceMessage, setMaintenanceMessage] = useState('');
  const location = useLocation();

  useEffect(() => {
    const fetchStatus = async () => {
      try {
        const response = await api.get('/parameters/system/status');
        if (response.data?.success && response.data.data) {
          setMaintenanceMode(!!response.data.data.maintenanceMode);
          setMaintenanceMessage(response.data.data.maintenanceMessage);
        }
      } catch (error) {
        console.error('Sistem durumu alınırken hata:', error);
        // Hata durumunda siteyi tamamen kilitlememek için bakım modunu devre dışı bırak
        setMaintenanceMode(false);
      } finally {
        setLoading(false);
      }
    };

    fetchStatus();
  }, []);

  // Admin ve auth ekranları bakım modundan muaf tutulur
  const pathname = location.pathname || '';
  const isAdminPath = pathname.startsWith('/admin');

  if (loading) {
    return children;
  }

  if (maintenanceMode && !isAdminPath) {
    return <MaintenancePage message={maintenanceMessage} />;
  }

  return children;
};

export default MaintenanceCheck;

